"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileExtension = exports.formatBytes = exports.calculatePercent = exports.calculatePercentChange = exports.formatNumber = void 0;
var formatNumber = function (value, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.unit, unit = _c === void 0 ? '' : _c, _d = _b.commas, commas = _d === void 0 ? true : _d;
    if (value === Number.POSITIVE_INFINITY) {
        return "" + '∞' + unit;
    }
    var finalValue = value;
    if (unit === '%') {
        finalValue = Math.round(value * 100);
    }
    var valueString = commas ? finalValue.toLocaleString() : finalValue.toString();
    return "" + valueString + unit;
};
exports.formatNumber = formatNumber;
var calculatePercentChange = function (currentValue, prevValue) {
    var percentChange = currentValue / prevValue - 1;
    if (prevValue === 0) {
        percentChange = currentValue === 0 ? 0 : Number.POSITIVE_INFINITY;
    }
    return percentChange;
};
exports.calculatePercentChange = calculatePercentChange;
var calculatePercent = function (numerator, denominator) {
    var percent = numerator / denominator;
    if (denominator === 0) {
        percent = numerator === 0 ? 0 : Number.POSITIVE_INFINITY;
    }
    return percent;
};
exports.calculatePercent = calculatePercent;
var formatBytes = function (bytes, decimals) {
    if (decimals === void 0) { decimals = 2; }
    if (bytes === 0) {
        return '0 Bytes';
    }
    var k = 1024;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + " " + sizes[i];
};
exports.formatBytes = formatBytes;
var getFileExtension = function (fileName) { var _a; return fileName.indexOf('.') > -1 ? (_a = fileName.split('.').pop()) !== null && _a !== void 0 ? _a : '' : ''; };
exports.getFileExtension = getFileExtension;
